import React from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import AssetCodeTable from '../../AppGrid/AssetCodeTable';

const AssetCodeList = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const navigate = useNavigate();
	const assetId = searchParams.get('assetId');
	const handleOnSetActiveRecord = (record, opts) => {
		if (!record) {
			navigate(`/asset`);
		}
		else {
			navigate(`/assetscode?assetId=${assetId}&id=${record?.id}`);
		}
	}
	return (
		<AssetCodeTable
			parentFilters={{ assetId }}
			initialValues={{ assetId }}
			onSetActiveRecord={handleOnSetActiveRecord}
		/>
	);
};
export default AssetCodeList;
